import React from 'react';
import ModalContainer from 'components/shared/modal/modal_container';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import { Icon } from 'ui';
import RenderInBody from 'components/shared/render_in_body';

const LessonGenerateModal = ({ closeModal }) => {
  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={closeModal}
      >
        <div className="ModalTakeover-container LessonCreationModal">
          <div className="LessonCreationModal-body">
            <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="pb-24">
              Generate Lesson Modal Placeholder
            </Text>
            <button
              type="button"
              className="u-resetBtn ModalTakeover-closeButton"
              aria-label={t('common.close')}
              onClick={closeModal}
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

export default LessonGenerateModal;
